<div id="message">
  <p>Password must contain:</p>
  <div class="criteria">
    <div *ngFor="let item of criteria" class="{{ item.class }}" id="{{ item.id }}">
      {{ item.content }}
    </div>
  </div>
</div>
